import React from 'react';
import { Card, Table, Tag, Space, Button } from 'antd';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';

const STATUS_COLORS = {
  pending: 'gold',
  confirmed: 'green',
  rejected: 'red',
};

const STATUS_FILTERS = [
  { text: 'Pending', value: 'pending' },
  { text: 'Confirmed', value: 'confirmed' },
  { text: 'Rejected', value: 'rejected' },
];

const fakeProducts = [
  { id: 'P-1001', name: 'Stéthoscope Classic', category: 'Équipement', price: 89.9, stock: 42, status: 'confirmed' },
  { id: 'P-1002', name: 'Tensiomètre Pro', category: 'Équipement', price: 59.0, stock: 0, status: 'pending' },
  { id: 'P-1003', name: 'Gel hydroalcoolique 500ml', category: 'Consommable', price: 4.9, stock: 320, status: 'confirmed' },
  { id: 'P-1004', name: 'Masques FFP2 (x20)', category: 'Consommable', price: 24.5, stock: 85, status: 'rejected' },
];

export default function Products() {
  const columns = [
    { title: 'Réf.', dataIndex: 'id', key: 'id', width: 120 },
    { title: 'Produit', dataIndex: 'name', key: 'name' },
    { title: 'Catégorie', dataIndex: 'category', key: 'category', width: 150 },
    {
      title: 'Prix',
      dataIndex: 'price',
      key: 'price',
      align: 'right',
      width: 120,
      render: (p) => `${p.toFixed(2)} €`,
      sorter: (a, b) => a.price - b.price,
    },
    {
      title: 'Stock',
      dataIndex: 'stock',
      key: 'stock',
      align: 'right',
      width: 100,
      sorter: (a, b) => a.stock - b.stock,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 140,
      render: (s) => <Tag color={STATUS_COLORS[s]}>{s.charAt(0).toUpperCase() + s.slice(1)}</Tag>,
      filters: STATUS_FILTERS,
      onFilter: (v, r) => r.status === v,
    },
  ];

  return (
    <Card
      title="Products"
      extra={
        <Space>
          <Button icon={<ReloadOutlined />}>Rafraîchir</Button>
          <Button type="primary" icon={<PlusOutlined />}>
            Nouveau produit
          </Button>
        </Space>
      }
    >
      <Table
        rowKey="id"
        columns={columns}
        dataSource={fakeProducts}
        pagination={{ pageSize: 8, showSizeChanger: false }}
      />
    </Card>
  );
}